module.exports = {
  'en': {
    'HRMS18E': {
      '10': 'For Department',
      '20': 'Group',
      '25': 'or Employee ID',
      '30': 'Month',
      '40': 'Year',
      '50': 'Change Month',
      '60': 'Change Year',
      '70': 'Employee Name',
      '80': 'Type of Day',
      '90': 'Working Day',
      '100': 'Holiday',
      '110': 'Traditional Day',
      '120': 'Leave',
      '130': 'Shut down',
      '140': 'Change Schedule and Actual Time',
      '150': 'Employee',
      '160': 'Date',
      '170': 'Type of Day',
      '180': 'Group',
      '190': 'Shift 1',
      '200': 'Act. Date in',
      '210': 'Time',
      '220': 'Act. Date out',
      '230': 'Time',
      '240': 'Reasons',
      '250': 'Need clock in/out',
      '260': 'Yes',
      '270': 'No',
      '280': 'Times Forgot Time Stamp',
      '290': 'Type of Day (Specail Shift)',
      '300': 'Group',
      '310': 'Shift 2 (Specail)',
      '320': 'Act. Date in',
      '330': 'Time',
      '340': 'Act. Date out',
      '350': 'Time',
      '360': 'Reasons',
      '370': 'Need clock in/out',
      '380': 'Yes',
      '390': 'No',
      '400': 'Times Forgot Time Stamp',
      '410': 'From Employee ID',
      '420': 'To Employee ID',
      '430': 'From Date',
      '440': 'To Date'
    },
    'CODSHIFT': {
      '01': '1',
      '02': '2',
      '03': '3',
      '04': '4',
      '05': '5',
      '06': '6',
      '07': '7',
      '08': '8',
      '09': '9',
      '10': '10',
      '11': '11',
      '12': '12',
      '13': '13',
      '14': '14',
      '15': '15',
      '16': '16',
      '17': '17',
      '18': '18',
      '19': '19',
      '20': '20',
      '21': '21',
      '22': '22',
      '23': '23',
      '24': '24',
      '25': '25',
      '26': '26',
      '27': '27',
      '28': '28',
      '29': '29',
      '30': '30',
      '31': '31'
    }
  },
  'th': {
    'HRMS18E': {
      '10': 'สำหรับหน่วยงาน',
      '20': 'กลุ่มการทำงาน',
      '25': 'หรือ รหัสพนักงาน',
      '30': 'เดือน',
      '40': 'ปี',
      '50': 'เปลี่ยนเดือน',
      '60': 'เปลี่ยนปี',
      '70': 'ชื่อพนักงาน',
      '80': 'ประเภทวันทำงาน',
      '90': 'เวลาทำงานปกติ',
      '100': 'วันหยุด',
      '110': 'วันหยุดประเพณี',
      '120': 'การลา',
      '130': 'Shut down',
      '140': 'แก้ไขเวลาปฏิบัติงาน และเวลารูดบัตร',
      '150': 'พนักงาน',
      '160': 'วันที่',
      '170': 'ประเภทวันทำงาน',
      '180': 'กลุ่มการทำงาน',
      '190': 'รหัสกะ 1',
      '200': 'วันที่รูดเข้า',
      '210': 'เวลา',
      '220': 'วันที่รูดออก',
      '230': 'เวลา',
      '240': 'เหตุผลการแก้ไข',
      '250': 'การรูดบัตร',
      '260': 'รูดบัตร',
      '270': 'ไม่รูดบัตร',
      '280': 'จำนวนครั้งลืมรูดบัตร',
      '290': 'ประเภทวันทำงาน (กะแทน)',
      '300': 'กลุ่มการทำงาน',
      '310': 'รหัสกะ 2 (แทน)',
      '320': 'วันที่รูดเข้า',
      '330': 'เวลา',
      '340': 'วันที่รูดออก',
      '350': 'เวลา',
      '360': 'เหตุผลการแก้ไข',
      '370': 'การรูดบัตร',
      '380': 'รูดบัตร',
      '390': 'ไม่รูดบัตร',
      '400': 'จำนวนครั้งลืมรูดบัตร',
      '410': 'รหัสพนักงานตั้งแต่',
      '420': 'ถึงรหัสพนักงาน',
      '430': 'ตั้งแต่วันที่',
      '440': 'ถึงวันที่'
    },
    'CODSHIFT': {
      '01': '',
      '02': '',
      '03': '',
      '04': '',
      '05': '',
      '06': '',
      '07': '',
      '08': '',
      '09': '',
      '10': '',
      '11': '',
      '12': '',
      '13': '',
      '14': '',
      '15': '',
      '16': '',
      '17': '',
      '18': '',
      '19': '',
      '20': '',
      '21': '',
      '22': '',
      '23': '',
      '24': '',
      '25': '',
      '26': '',
      '27': '',
      '28': '',
      '29': '',
      '30': '',
      '31': ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms18e.js